import { Record, List } from 'immutable';
import _ from 'lodash';

import Organization from '../organization/model';

const properties = {
  id: '',
  type: '',
  name: '',
  description: '',
  banner: undefined,
  picture: undefined,
  color: undefined,
  number: 0,
  sorting: 0,
  organization: undefined,
  individualsOnly: false,
  public: false,
  gradient: true,
  nonprofits: List(),
  code: '',
};

export const enum CauseTypes {
  Pillar = 'Pillar',
  CauseAreas = 'Cause Areas',
  ERG = 'ERG',
  Category = 'Category',
  SDG = 'SDG',
}

export default class Cause extends Record(properties, 'Cause') implements Cause {
  public readonly id!: string;

  public readonly type!: CauseTypes;

  public readonly name!: string;

  public readonly code!: string;

  public readonly description!: string;

  public readonly color!: string;

  public readonly banner!: string;

  public readonly picture!: string;

  public readonly number!: number;

  public readonly sorting!: number;

  public readonly organization!: string;

  public readonly individualsOnly!: boolean;

  public readonly public!: boolean;

  public readonly gradient!: boolean;

  public readonly nonprofits!: List<Organization>;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));

    super({
      ...validValues,
      type: values.type || values.__t,
      nonprofits:
        values.nonprofits &&
        List(values.nonprofits.map((nonprofit: Organization) => new Organization(nonprofit))),
    });
  }

  public label(): string {
    return this.type === CauseTypes.SDG ? `#${this.number} ${this.name}` : this.name;
  }

  public fieldName(): string {
    switch (this.type) {
      case CauseTypes.Pillar:
        return 'pillars';

      case CauseTypes.CauseAreas:
        return 'pillars';

      case CauseTypes.ERG:
        return 'ERGs';

      case CauseTypes.Category:
        return 'categories';

      case CauseTypes.SDG:
        return 'SDGs';

      default:
        return '';
    }
  }
}
